import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { GetStoreHoursRequest, GetStoreHoursResponse }
from 'app/components/partner/mart/partner-mart-locations/partner-mart-locations/partner-mart-locations-details/store-hours-details/store-hours-details.component';

@Injectable()
export class StoreService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getStoresByMerchant(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoresByMerchant', data, messageService);
    }

    public getStoresForCombo(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoresForCombo', null, messageService);
    }

    public createStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/CreateStore', data, messageService);
    }

    public editStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/EditStore', data, messageService);
    }

    public updateStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStore', data, messageService);
    }

    public getStore(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStore', data, messageService);
    }

    public approvedOrRejectStoreStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/ApprovedOrRejectStoreStatus', data, messageService);
    }

    public getStoresForGrid(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoresForGrid', data, messageService);
    }

    public getStoreGroupsForGrid(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoreGroupsForGrid', data, messageService);
    }

    public createStoreGroup(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/CreateStoreGroup', data, messageService);
    }

    public getStoreGroupForEdit(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoreGroupForEdit', data, messageService);
    }

    public updateStoreGroup(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStoreGroup', data, messageService);
    }

    public getStoreGroupHours(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoreGroupHours', data, messageService);
    }

    public updateStoreGroupHours(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStoreGroupHours', data, messageService);
    }

    public updateDeliveryDetail(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateDeliveryDetail', data, messageService);
    }

    public getStoreLegalDocuments(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoreLegalDocuments', data, messageService);
    }

    public updateStoreLegalDocs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStoreLegalDocs', data, messageService);
    }

    public updateStorePublishedStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStorePublishedStatus', data, messageService);
    }

    public deleteProduct(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/DeleteProduct', data, messageService);
    }

    public deleteProductItem(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/DeleteProductItem', data, messageService);
    }

    public getStoreHours(data: GetStoreHoursRequest, messageService: MessageService):
    Promise<GetStoreHoursResponse> {
        return this.apiHttp.post('api/AdminStore/GetStoreOperationHours', data, messageService);
    }

    public deleteStoreOperationHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/DeleteOperationHours', data, messageService);
    }

    public addStoreOperationHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/AddOperationHour', data, messageService);
    }

    public updateStoreOperationHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateSpecificOperationHour', data, messageService);
    }

    // Special Hours Methods
    public getStoreSpecialHours(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/GetStoreSpecialHours', data, messageService);
    }

    public addStoreSpecialHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/AddStoreSpecialHour', data, messageService);
    }

    public updateStoreSpecialHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/UpdateStoreSpecialHour', data, messageService);
    }

    public deleteStoreSpecialHour(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminStore/DeleteStoreSpecialHour', data, messageService);
    }
}
